module.exports = __webpack_public_path__ + "img/使用说明.495d5b3d.png";